import { Alpine } from '../core/alpine-core.js';

Alpine.data('setupWizard', () => ({
  step: 1,
  token: '',
  inviteRole: 'admin',
  sessionToken: '',
  password: '',
  password2: '',
  profile: { fullName: '', nickname: '', country: 'GB' },
  error: '',
  busy: false,

  init() {
    try {
      this.token = String(new URL(globalThis.location.href).searchParams.get('token') || '').trim();
    } catch {
      this.token = '';
    }
    if (!this.token) this.error = 'Missing setup token. Open the link from your email.';
  },

  mapSetupError(code, message) {
    if (message) return message;
    if (code === 'invalid_or_expired_token') {
      return 'This link is invalid, already used, or expired. Ask your admin for a new invite.';
    }
    if (code === 'password_too_short') return 'Password must be at least 8 characters.';
    return code || 'Setup failed';
  },

  async submitPassword() {
    this.error = '';
    if (String(this.password || '').length < 8) {
      this.error = 'Password must be at least 8 characters.';
      return;
    }
    if (this.password !== this.password2) {
      this.error = 'Passwords do not match.';
      return;
    }
    if (!this.token) {
      this.error = 'Missing setup token.';
      return;
    }
    this.busy = true;
    try {
      const res = await fetch('/api/auth/complete-setup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ token: this.token, password: this.password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(this.mapSetupError(data.error, data.message));

      const email = String(data.email || '').trim().toLowerCase();
      const loginRes = email
        ? await fetch('/api/auth/login', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username: email, password: this.password }),
        }).catch(() => null)
        : null;

      let role = String(data.role || 'admin').toLowerCase();
      if (loginRes?.ok) {
        const loginData = await loginRes.json().catch(() => ({}));
        this.sessionToken = loginData.token || loginData.accessToken || '';
        role = String(loginData.user?.role || loginData.player?.role || 'admin').toLowerCase();
        const me = loginData.player || loginData.user || {};
        if (this.sessionToken) {
          Alpine.store('session')?.set({ token: this.sessionToken, me });
          try {
            globalThis.localStorage?.setItem('dartsos.admin.token', this.sessionToken);
          } catch {
            /* ignore */
          }
        }
        this.profile.fullName = me.fullName || me.displayName || '';
        this.profile.nickname = me.nickname || '';
        this.profile.country = me.country || 'GB';
      }

      this.inviteRole = role;
      if (role === 'player') {
        this.step = 2;
        return;
      }
      globalThis.location.href = '/admin/dashboard';
    } catch (e) {
      this.error = e?.message || 'Setup failed';
    } finally {
      this.busy = false;
    }
  },

  async submitProfile() {
    this.error = '';
    this.busy = true;
    try {
      const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      if (this.sessionToken) headers.Authorization = `Bearer ${this.sessionToken}`;
      const res = await fetch('/api/auth/profile/complete', {
        method: 'POST',
        headers,
        body: JSON.stringify({
          fullName: String(this.profile.fullName || '').trim(),
          nickname: String(this.profile.nickname || '').trim(),
          country: String(this.profile.country || 'GB').trim().toUpperCase().slice(0, 2),
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || data.error || 'Profile save failed');
      globalThis.location.href = '/admin/dashboard';
    } catch (e) {
      this.error = e?.message || 'Profile save failed';
    } finally {
      this.busy = false;
    }
  },
}));
